import ArticleIcon from '@mui/icons-material/Article';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import LanguageIcon from '@mui/icons-material/Language';
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';

import Display from 'shared/components/Display';
import { DashboardConfigurationT } from 'shared/models/dashboard';

type GeneralInformationsProps = {
  data?: DashboardConfigurationT;
}
function GeneralInformations({ data }: GeneralInformationsProps) {
  const orgCloseDeviceLimit = data?.organizationsWithCloseDeviceLimit;
  return (
    <>
      <h3>General configuration</h3>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      >
        <Display.CardWithIcon
          svgName="building"
          iconColor="primary"
          name="Organizations"
          value={data?.organizations as number}
          badgeValue={orgCloseDeviceLimit as number}
          badgeColor="warning"
          iconTooltip={
            orgCloseDeviceLimit
              ? `${orgCloseDeviceLimit} organization${orgCloseDeviceLimit === 1 ? ' is' : 's are'} close to the device limit`
              : ''
            }
        />
        <Display.CardWithIcon
          icon={<SettingsRemoteIcon color="primary" />}
          name="Devices"
          value={data?.devices as number}
        />
        <Display.CardWithIcon
          svgName="folder"
          iconColor="primary"
          name="Sources"
          value={data?.sources as number}
        />
        <Display.CardWithIcon
          svgName="template"
          icon={<ArticleIcon color="primary" />}
          name="Device Profiles"
          value={data?.deviceProfiles as number}
        />
        <Display.CardWithIcon
          svgName="template"
          icon={<BackupTableIcon color="primary" />}
          name="SCHC Templates"
          value={data?.schcTemplates as number}
        />
        <Display.CardWithIcon
          svgName="ip"
          icon={<LanguageIcon color="primary" />}
          name="IP Networks"
          value={data?.ipNetworks as number}
        />
      </div>
    </>
  );
}

export default GeneralInformations;
